module.exports = __webpack_public_path__ + "static/img/brees-2008-top-image-thumb.e6b46c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2008-top-image-thumb.jpg
// module id = ZYIl
// module chunks = 1